import { causePoints } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function CauseSection() {
  return (
    <section id="cause" className="w-full bg-background-50">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14">
        <Reveal>
          <div className="relative h-[280px] w-full overflow-hidden rounded-lg border border-background-200 sm:h-[380px] lg:h-[460px]">
            <img
              src="https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20scattered%20documents%20and%20paper%20clippings%20on%20a%20warm%20cream%20surface%20with%20a%20deep%20red%20accent%20object%2C%20top%20down%20composition%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20layout%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail&width=1000&height=1200&seq=hej-cause-01&orientation=portrait"
              alt="海角黑料起因相关背景线索整理"
              title="海角黑料起因背景线索"
              className="h-full w-full object-top"
            />
          </div>
        </Reveal>

        <div>
          <span className="text-xs font-medium tracking-[0.2em] text-primary-600">ORIGIN</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            事件起因：三点关键背景
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            想理解海角黑料事件的走向，先要理解它的起点。海角黑料起因不是某一条消息单独造成的，而是三条线在相近时间交汇的结果。
          </p>

          <ol className="mt-7 space-y-5">
            {causePoints.map((point, index) => (
              <Reveal key={point.title} delay={index * 90}>
                <li className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-50 font-heading text-sm font-bold text-primary-600">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {point.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                      {point.desc}
                    </p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}